'use strict';

var promisify = require('promisify-es6');

var pull = require('pull-stream/pull');

module.exports = function ping(self) {
  return promisify(function (peerId, opts, callback) {
    if (typeof opts === 'function') {
      callback = opts;
      opts = {};
    }

    pull(self.pingPullStream(peerId, opts), pull.collect(callback));
  });
};